import { Form } from "antd";
import { useEffect } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import AiMedicineListItemForm from "./AiMedicineListItemForm";

const AiMedForm = ({ form, editData, onLastDelete }) => {
  useEffect(() => {
    if (editData?.medications) {
      form.setFieldsValue({
        medications: editData.medications,
      });
    }
  }, [editData?.medications]);

  return (
    <Form.List name="medications">
      {(fields, { remove }) =>
        fields.map((field) => (
          <div
            key={field.key}
            style={{
              display: "flex",
              gap: 12,
              alignItems: "flex-start",
              borderBottom: "1px dashed #ddd",
              paddingBottom: 10,
              marginBottom: 10,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <AiMedicineListItemForm
                form={form}
                field={field}
                // Remove editItem prop - let the form field manage its own value
              />
            </div>

            <DeleteOutlined
              onClick={() => {
                remove(field.name);
                if (fields.length === 1) {
                  onLastDelete();
                }
              }}
              style={{
                color: "red",
                fontSize: 20,
                cursor: "pointer",
                marginTop: 10,
              }}
            />
          </div>
        ))
      }
    </Form.List>
  );
};

export default AiMedForm;
